import React, { useEffect, useState } from "react";
import { changeAllCanteenUsersValue, changeCurrentUserValue } from "./store/slices/APIResponseSlice"
import { getDynamicLabel, handleError, isTypeOf } from "./utils/helpers"
import { getCanteenUser, getCurrentUser } from "./services/ApiServices"
import { Route, Routes as DomRouter } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-hot-toast"

import OrderDetails from "./components/OrderDetails/OrderDetails"
import CreateOrder from "./components/CreateOrder/CreateOrder"
import Overview from "./components/Overview/Overview"
import Loader from "./components/Loader/Loader"
import Header from "./components/Header/Header"
import Order from "./components/Order/Order"
import Error from "./components/Error/Error"
import User from "./components/User/User"

export default function Routes() {
  const orderTranslation = useSelector((state) => state.Translation.OrderTranslation)

  const [isLoading, setIsLoading] = useState(true)
  const [hasEnoughRights, setHasEnoughRights] = useState(undefined)

  const dispatch = useDispatch()

  useEffect(() => {
    setIsLoading(true)
    getCanteenUser().then((response) => {
      if (response?.Status === 200) {
        dispatch(changeAllCanteenUsersValue(response?.Data))
        setHasEnoughRights(true)
        setIsLoading(false)
      } else if (response?.Status === 403) {
        setHasEnoughRights(false)
        setIsLoading(false)
      }
    }).catch((error) => {
      setIsLoading(false)
      toast.error(error)
    })
  }, [])

  // Get Current User Data
  useEffect(() => {
    setIsLoading(true)
    getCurrentUser().then((response) => {
      if (isTypeOf(response, "object") && response?.Email) {
        dispatch(changeCurrentUserValue(response))
      } else {
        handleError(response, "Get Current User Error:")
      }
    }).catch((error) => {
      handleError(error, "Get Current User Error:")
    }).finally(() => {
      setIsLoading(false)
    })
  }, [])

  return (
    <>
      {isLoading && <Loader />}
      {hasEnoughRights === true &&
        <>
          <Header />
          <main id="main" className="main">
            <DomRouter>
              <Route path="/" element={<Order />} />
              <Route path="/Overview" element={<Overview />} />
              <Route path="/order/create-order" element={<CreateOrder />} />
              <Route path="/order-details/:orderId" element={<OrderDetails />} />
              <Route path="/users" element={<User />} />
              <Route path="*" element={<Error Status={404} Message={getDynamicLabel(orderTranslation?.msgWarnPageDoesNotExist, "The page you are looking for doesn't exist.")} />} />
            </DomRouter>
          </main>
        </>
      }
      {hasEnoughRights === false &&
        <Error Status={403} Message={getDynamicLabel(orderTranslation?.msgWarnNotAllowedPermissionAccess, "You do not have permission to access this resource. Please try again once you got the access.")} />
      }
    </>
  )
}
